import '@babel/polyfill';
import 'classlist-polyfill';

// Expose global jQuery variable
window.jQuery = window.$ = jQuery;

import '../utils/siteNamespace';
import initFullPage from '../modules/initFullPage';
import toggleMobileMenu from '../modules/toggleMobileMenu';
import closeMobileMenu from '../modules/closeMobileMenu';
import servicesSlider from '../modules/servicesSlider';
import ourClientsSlider from '../modules/ourClientsSlider';
import casesFiltering from '../modules/casesFiltering';
import casesSlider from '../modules/casesSlider';
import vacanciesSlider from '../modules/vacanciesSlider';
import vacanciesFiltering from '../modules/vacanciesFiltering';
import universalModal from '../modules/universalModal';
import tabs from '../modules/tabs';
import updateFileLabel from '../modules/updateFileLabel';
import customInputMask from '../modules/customInputMask';
import formValidation from '../modules/formValidation';

$(() => {
    initFullPage();
    toggleMobileMenu();
    closeMobileMenu();
    servicesSlider();
    ourClientsSlider();
    casesFiltering();
    casesSlider();
    vacanciesSlider();
    vacanciesFiltering();
    universalModal();
    tabs.init();
    updateFileLabel();
    customInputMask();
    formValidation();
});
